<template>
  <div class="DeviceManagement">
    <el-form :inline="true"
             :model="searchForm"
             @keyup.enter.native="getDataList('search')">
      <el-form-item label="房间号">
        <el-select v-model="searchForm.apartmentAssetCode"
                   @change="getDataList('search')">
          <el-option v-for="item in homeList"
                     :key="item.apartmentAssetCode"
                     :label="item.apartmentAssetName"
                     :value="item.apartmentAssetCode" />
        </el-select>
      </el-form-item>
      <el-form-item label="设备名称">
        <el-input v-model="searchForm.apartmentDeviceName"
                  placeholder="设备名称"></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select v-model="searchForm.apartmentDeviceType">
          <el-option v-for="item in deviceTypeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-select v-model="searchForm.apartmentDeviceStatus">
          <el-option v-for="item in deviceStatusList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search"
                   size="small"
                   type="primary"
                   @click="getDataList('search')">搜索
        </el-button>
        <el-button icon="el-icon-delete"
                   size="small"
                   plain
                   type="primary"
                   @click="reset()">清空
        </el-button>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <!--
          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openRegisterDialog()">注册设备
          </el-button>
          -->
          <el-button icon="el-icon-plus"
                     size="small"
                     type="primary"
                     @click="openModifyDialog()">添加设备
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName"
             @tab-click="handleClick"
             style="margin-top: 20px;">

      <el-tab-pane :label="item.apartmentName"
                   :name="item.apartmentCode"
                   v-for="(item, index) in apartmentlist"
                   :key="index">

        <el-table class="dataTable"
                  v-loading="dataListLoading"
                  :data="dataList"
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  border>
	      <el-table-column label="所属房间"
                           prop="apartmentAssetName">
          </el-table-column>
          <el-table-column label="设备名称"
                           prop="apartmentDeviceName">
          </el-table-column>
          <!-- <el-table-column label="设备ID"
                           prop="deviceCode">
          </el-table-column> -->
          <!-- <el-table-column label="IMEI"
                           prop="deviceName">
          </el-table-column> -->
          <el-table-column label="设备类型"
                           prop="apartmentDeviceType">
            <template slot-scope="scope">
              <span>{{ scope.row.apartmentDeviceType == 0 ? '普通锁' : '门禁锁' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备状态"
                           prop="apartmentDeviceStatus">
            <template slot-scope="scope">
              <span>{{ scope.row.apartmentDeviceStatus == 0 ? '离线' : '在线' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Model"
                           prop="apartmentDeviceModel">
          </el-table-column>
          <el-table-column label="创建时间"
                           prop="createdTime">
          </el-table-column>
          <el-table-column label="操作"
                           width="400">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="primary"
                         @click="openDetailDialog(scope.row)">查看</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="openModifyDialog(scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page="pageIndex"
                       :page-size="pageSize"
                       :page-sizes="[10, 20, 50, 100]"
                       :total="totalPage"
                       background
                       layout="total, sizes, prev, pager, next, jumper"
                       @size-change="sizeChangeHandle"
                       @current-change="currentChangeHandle">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- 注册设备 -->
    <el-dialog title="注册设备"
               :visible.sync="registerDialog"
               width="40%"
               :before-close="cancelRegisterDialog">
      <el-form class="registerForm"
               ref="registerForm"
               :model="registerForm"
               :rules="registerRule"
               label-width="40%">
        <el-form-item label="设备名称"
                      prop="apartmentDeviceName">
          <el-input style="width: 200px;"
                    v-model="registerForm.apartmentDeviceName"
                    placeholder="请输入设备名称"
                    @keyup.enter.native="registerHandle()"></el-input>
        </el-form-item>
        <el-form-item label="设备描述"
                      prop="devFeature">
          <el-input style="width: 200px;"
                    v-model="registerForm.devFeature"
                    placeholder="请输入设备描述"
                    @keyup.enter.native="registerHandle()"></el-input>
        </el-form-item>
        <el-form-item label="IMEI"
                      prop="devIMEI">
          <el-input style="width: 200px;"
                    v-model="registerForm.devIMEI"
                    placeholder="请输入IMEI"
                    @keyup.enter.native="registerHandle()"></el-input>
        </el-form-item>
        <el-form-item label="Mac"
                      prop="devMac">
          <el-input style="width: 200px;"
                    v-model="registerForm.devMac"
                    placeholder="请输入Mac地址"
                    @keyup.enter.native="registerHandle()"></el-input>
        </el-form-item>
        <el-form-item label="Model"
                      prop="apartmentDeviceModel">
          <el-input style="width: 200px;"
                    v-model="registerForm.apartmentDeviceModel"
                    placeholder="请输入Model"
                    @keyup.enter.native="registerHandle()"></el-input>
        </el-form-item>
        <el-form-item label="id"
                      prop="deviceId">
          <el-input style="width: 200px;"
                    v-model="registerForm.deviceId"
                    placeholder="请输入id"
                    @keyup.enter.native="registerHandle()"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelRegisterDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="registerHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增&修改设备信息 -->
    <el-dialog :title="modifyForm.id ? '修改设备信息' : '添加设备'"
               :visible.sync="modifyDialog"
               width="40%"
               :before-close="cancelModifyDialog">
      <el-form class="modifyForm"
               ref="modifyForm"
               :model="modifyForm"
               :rules="modifyRule"
               label-width="40%">
        <el-form-item label="所属房间"
                      prop="apartmentAssetCode">
          <el-select v-model="modifyForm.apartmentAssetCode">
            <el-option v-for="item in homeList"
                       :key="item.apartmentAssetCode"
                       :label="item.apartmentAssetName"
                       :value="item.apartmentAssetCode" />
          </el-select>
        </el-form-item>

        <el-form-item label="设备名称"
                      prop="apartmentDeviceName">
          <el-input style="width: 200px;"
                    v-model="modifyForm.apartmentDeviceName"
                    placeholder="请输入设备名称"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="设备型号"
                      prop="apartmentDeviceModel">
          <el-input style="width: 200px;"
                    v-model="modifyForm.apartmentDeviceModel"
                    placeholder="请输入设备型号"
                    :disabled="!!modifyForm.id"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>

        <el-form-item label="设备ID"
                      prop="apartmentDeviceCode">
          <el-input style="width: 200px;"
                    v-model="modifyForm.apartmentDeviceCode"
                    placeholder="请输入设备ID"
                    :disabled="!!modifyForm.id"
                    @keyup.enter.native="modifyHandle()"></el-input>
        </el-form-item>
        <!-- <el-form-item label="设备类型"
                      prop="apartmentDeviceType">
          <el-radio-group v-model="modifyForm.apartmentDeviceType"
                          size="small">
            <el-radio v-for="item in deviceTypeList"
                      :key="item.value"
                      :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="设备状态"
                      prop="apartmentDeviceStatus">
          <el-radio-group v-model="modifyForm.apartmentDeviceStatus"
                          size="small">
            <el-radio v-for="item in deviceStatusList"
                      :key="item.value"
                      :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelModifyDialog()">取 消</el-button>
        <el-button type="primary"
                   @click="modifyHandle()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 设备信息详情 -->
    <el-dialog title="设备信息详情"
               :visible.sync="detailDialog"
               width="40%"
               :before-close="cancelDetailDialog">
      <el-form class="detailForm"
               ref="detailForm"
               :model="detailForm"
               label-width="40%">
        <el-form-item label="设备名称"
                      prop="apartmentDeviceName">
          <span>{{ detailForm.apartmentDeviceName}}</span>
        </el-form-item>
        <el-form-item label="设备ID "
                      prop="deviceCode">
          <span>{{ detailForm.deviceCode}}</span>
        </el-form-item>
        <!-- <el-form-item label="IMEI"
                      prop="devIMEI">
          <span>{{ detailForm.devIMEI}}</span>
        </el-form-item>
        <el-form-item label="Mac地址"
                      prop="devMac">
          <span>{{ detailForm.devMac}}</span>
        </el-form-item> -->
        <el-form-item label="Model"
                      prop="apartmentDeviceModel">
          <span>{{ detailForm.apartmentDeviceModel }}</span>
        </el-form-item>
        <!-- <el-form-item label="设备描述"
                      prop="devFeature">
          <span>{{ detailForm.devFeature}}</span>
        </el-form-item> -->
        <el-form-item label="设备类型："
                      prop="apartmentDeviceType">
          <span>{{ detailForm.apartmentDeviceType == 0 ? '普通锁' : '门禁锁' }}</span>
        </el-form-item>
        <el-form-item label="设备状态："
                      prop="apartmentDeviceStatus">
          <span>{{ detailForm.apartmentDeviceStatus == 0 ? '离线' : '在线' }}</span>
        </el-form-item>
        <el-form-item label="所属房间："
                      prop="apartmentAssetName">
          <span>{{ detailForm.apartmentAssetName}}</span>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex;justify-content: space-between">
        <el-button @click="cancelDetailDialog()">返 回</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import '../assets/css/DeviceManagement.css'
export default {
  data() {
    return {
      apartmentCode: '',
      apartmentlist: [],
      homeList: [],
      activeName: '',
      searchForm: {},
      deviceTypeList: [
        {
          value: 0,
          label: '普通锁',
        },
        {
          value: 1,
          label: '门禁锁',
        },
      ],
      deviceStatusList: [
        {
          value: 0,
          label: '离线',
        },
        {
          value: 1,
          label: '在线',
        },
      ],
      roomEquipmentList: [],
      roomTenantList: [],
      dataListLoading: false,
      dataList: [],
      pageIndex: 0,
      pageSize: 10,
      totalPage: 0,
      registerDialog: false,
      registerForm: {},
      registerRule: {
        apartmentDeviceName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' },
        ],
        apartmentName: [
          { required: true, message: '所属公寓不能为空', trigger: 'blur' },
        ],
        apartmentAssetType: [
          { required: true, message: '请选择设备类型', trigger: 'blur' },
        ],
        apartmentAssetStatus: [
          { required: true, message: '请选择设备状态', trigger: 'blur' },
        ],
      },
      modifyDialog: false,
      modifyForm: {},
      modifyRule: {
        apartmentDeviceName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' },
        ],
        apartmentDeviceCode: [
          { required: true, message: '设备编码不能为空', trigger: 'blur' },
        ],
        apartmentDeviceModel: [
          { required: true, message: '设备型号不能为空', trigger: 'blur' },
        ],
      },
      detailDialog: false,
      detailForm: {},
      apartmentAssetCodeOld: '',
      apartmentAssetNameOld: '',
    }
  },

  computed: {},

  created() {
    let self = this

    self.getApartmentlist()
  },

  mounted() {},

  methods: {
    handleClick(tab, event) {
      let self = this

      self.apartmentCode = tab.name

      let str = {
        apartmentCode: self.apartmentCode,
        flag: 1,
      }
      self.getHomeList(str)
    },
    // 清空查询条件
    reset() {
      let self = this
      Object.keys(self.searchForm).forEach((key) => (self.searchForm[key] = ''))
    },

    // 获取公寓列表
    getApartmentlist() {
      let self = this

      self.$axios
        ._getApartmentlist()
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.apartmentlist = datas.data

            self.activeName = self.apartmentlist[0].apartmentCode
            self.apartmentCode = self.apartmentlist[0].apartmentCode

            let str = {
              apartmentCode: self.apartmentlist[0].apartmentCode,
              flag: 1,
            }
            self.getHomeList(str)
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取房间列表
    getHomeList(fristApartment) {
      let self = this

      let str = fristApartment

      self.$axios
        ._getHomelist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.homeList = datas.data.content
            self.searchForm.apartmentAssetCode =
              self.homeList[0].apartmentAssetCode

            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },

    // 获取设备列表
    getDataList(type) {
      let self = this

      if (!self.searchForm.apartmentAssetCode) {
        self.$message.error('请选择房间号')
        return
      }
      self.dataListLoading = true

      if (type == 'search') {
        self.pageIndex = 0
      }

      let str = {
        apartmentCode: self.apartmentCode,
        flag: 4,
        pageNow: self.pageIndex,
        pageSize: self.pageSize,
        param: self.searchForm.apartmentAssetCode,
      }

      self.$axios
        ._getDevicelist(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.dataList = datas.data.content
            self.totalPage = datas.data.totalElements
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },

    // 每页数
    sizeChangeHandle(val) {
      let self = this

      self.pageSize = val
      self.pageIndex = 0
      self.getDataList()
    },

    // 当前页
    currentChangeHandle(val) {
      let self = this

      self.pageIndex = val
      self.getDataList()
    },

    // 打开 注册设备弹窗
    openRegisterDialog: function (row) {
      let self = this

      self.registerDialog = true
    },

    // 注册设备
    registerHandle: function () {
      let self = this

      let deviceName = self.registerForm.apartmentDeviceName
      let devFeature = Number(self.registerForm.devFeature)
      let devIMEI = self.registerForm.devIMEI
      let devMac = self.registerForm.devMac
      let devModel = self.registerForm.apartmentDeviceModel
      let deviceId = self.registerForm.deviceId

      // let str = {
      //   deviceName: deviceName,
      //   devFeature: devFeature,
      //   devIMEI: devIMEI,
      //   devMac: devMac,
      //   devModel: devModel,
      //   deviceId: deviceId,
      // }

      let formdata = new FormData()

      formdata.append('deviceName', deviceName)
      formdata.append('devIMEI', devIMEI)
      formdata.append('devFeature', devFeature)
      formdata.append('devMac', devMac)
      formdata.append('devModel', devModel)
      formdata.append('deviceId', deviceId)

      self.$axios
        ._registerDevice(formdata)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.cancelRegisterDialog()
            self.$message.success('注册成功')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })
    },
    // 关闭 注册设备弹窗
    cancelRegisterDialog: function () {
      let self = this

      Object.keys(self.registerForm).forEach(
        (key) => (self.registerForm[key] = '')
      )

      self.registerDialog = false
    },

    // 打开 新增&修改弹窗
    openModifyDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          apartmentCode: self.apartmentCode,
          flag: 5,
          param: row.apartmentDeviceCode,
        }

        self.$axios
          ._getDevicelist(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              if (datas.data.content.length > 0) {
                self.modifyForm = datas.data.content[0]

                self.apartmentAssetCodeOld = self.modifyForm.apartmentAssetCode

                let obj = {}

                self.homeList.map((item) => {
                  item.apartmentAssetCode == self.apartmentAssetCodeOld &&
                    (obj = item)
                })

                self.apartmentAssetNameOld = obj.apartmentAssetName
              }
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.modifyDialog = true
    },

    // 新增&修改
    modifyHandle: function () {
      let self = this

      if (!self.modifyForm.apartmentAssetCode) {
        self.$message.error('请选择房间号')
        return
      }

      let apartmentCode = self.apartmentCode
      let apartmentAssetCode = self.modifyForm.apartmentAssetCode
      let apartmentDeviceName = self.modifyForm.apartmentDeviceName
      let apartmentDeviceCode = self.modifyForm.apartmentDeviceCode
      let apartmentDeviceModel = self.modifyForm.apartmentDeviceModel
      let apartmentDeviceType = self.modifyForm.apartmentDeviceType
      let apartmentDeviceStatus = self.modifyForm.apartmentDeviceStatus


      let obj = {}

      self.homeList.map((item) => {
        item.apartmentAssetCode == apartmentAssetCode && (obj = item)
      })

      let apartmentAssetName = obj.apartmentAssetName

      if (self.modifyForm.id) {
        let str = {
          apartmentCode: apartmentCode,
          apartmentAssetCode: apartmentAssetCode,
          // apartmentAssetName: self.apartmentAssetNameOld,
          apartmentDeviceName: apartmentDeviceName,
          apartmentDeviceCode: apartmentDeviceCode,
          // apartmentDeviceType: apartmentDeviceType,
          // apartmentDeviceStatus: apartmentDeviceStatus,
        }

        self.$axios
          ._putDeviceInfo(str)
          .then((res) => {
            const datas = res.data
            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('修改成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      } else {
        let formdata = new FormData()

        formdata.append('apartmentCode', apartmentCode)
        formdata.append('apartmentAssetCode', apartmentAssetCode)
        formdata.append('apartmentAssetName', apartmentAssetName)
        formdata.append('deviceName', apartmentDeviceName)
        formdata.append('deviceCode', apartmentDeviceCode)
        formdata.append('deviceModel', apartmentDeviceModel)
        // formdata.append('apartmentDeviceType', apartmentDeviceType)
        // formdata.append('apartmentDeviceStatus', apartmentDeviceStatus)

        self.$axios
          ._addDeviceInfo(formdata)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.cancelModifyDialog()
              self.getDataList('search')
              self.$message.success('添加成功')
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }
    },

    // 关闭 新增&修改弹窗
    cancelModifyDialog: function () {
      let self = this

      Object.keys(self.modifyForm).forEach((key) => (self.modifyForm[key] = ''))
      self.$refs.modifyForm.resetFields()
      self.modifyDialog = false
    },

    // 打开 设备信息弹窗
    openDetailDialog: function (row) {
      let self = this

      if (row) {
        let str = {
          apartmentCode: self.apartmentCode,
          flag: 5,
          param: row.apartmentDeviceCode,
        }
        self.$axios
          ._getDevicelist(str)
          .then((res) => {
            const datas = res.data

            if (datas.code == 0) {
              self.detailForm = datas.data.content[0]
            } else {
              self.$message.closeAll()
              self.$message.error(datas.msg)
            }
          })
          .catch((error) => {
            self.$message.closeAll()
            self.$message.error('系统异常，请联系管理员')
          })
      }

      self.detailDialog = true
    },

    // 关闭 设备信息弹窗
    cancelDetailDialog: function () {
      let self = this

      Object.keys(self.detailForm).forEach((key) => (self.detailForm[key] = ''))

      self.detailDialog = false
    },

    // 删除设备
    handleDelete(row) {
      let self = this

      let apartmentCode = row.apartmentCode
      let apartmentDeviceCode = row.apartmentDeviceCode

      let str = `?apartmentCode=${apartmentCode}&apartmentDeviceCode=${apartmentDeviceCode}`
      self
        .$confirm(`是否确认要删除 "${row.apartmentDeviceName}" 设备`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(function () {
          return self.delDevice(str)
        })
        .then((data) => {})
    },

    delDevice(str) {
      let self = this

      self.$axios
        ._deleteDevice(str)
        .then((res) => {
          const datas = res.data

          if (datas.code == 0) {
            self.$message.success('删除成功')
            self.getDataList('search')
          } else {
            self.$message.closeAll()
            self.$message.error(datas.msg)
          }
        })
        .catch((error) => {
          self.$message.closeAll()
          self.$message.error(datas.msg)
        })

      self.dataListLoading = false
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/DeviceManagement.vue